import { useState } from "react";
import { Play } from "lucide-react";

export function driveId(link = "") {
  const m = link.match(/\/file\/d\/([a-zA-Z0-9_-]+)/) || link.match(/[?&]id=([a-zA-Z0-9_-]+)/);
  return m ? m[1] : null;
}

export function DriveImage({ link, alt, className = "", imgClassName = "", width, height, eager = false, focus = "center top", onLoad }) {
  const id = driveId(link);
  const [stage, setStage] = useState(0); // 0 = drive thumbnail, 1 = lh3 fallback, 2 = hide
  if (!id || stage === 2) return null;
  const size = width && width <= 128 ? "w200" : width && width <= 640 ? "w800" : "w1200";
  const src =
    stage === 0
      ? `https://drive.google.com/thumbnail?id=${id}&sz=${size}`
      : `https://lh3.googleusercontent.com/d/${id}=${size}`;
  return (
    <div className={className}>
      <img
        src={src}
        alt={alt}
        loading={eager ? "eager" : "lazy"}
        width={width}
        height={height}
        onLoad={onLoad}
        onError={() => setStage(stage + 1)}
        className={imgClassName}
        style={{ objectFit: "cover", objectPosition: focus }}
      />
    </div>
  );
}

export function DriveVideo({ link, orientation = "horizontal", name = "", caption = "" }) {
  const id = driveId(link);
  const [playing, setPlaying] = useState(false);
  const [thumbStage, setThumbStage] = useState(0);
  if (!id) return null;
  const frameCls =
    orientation === "vertical"
      ? "aspect-[9/16] max-w-[320px] mx-auto"
      : "aspect-video";
  return (
    <figure data-testid={`drive-video-${id}`}>
      <div className={`relative w-full ${frameCls} rounded-2xl overflow-hidden border border-ink/10 bg-ink`}>
        {playing ? (
          <iframe
            src={`https://drive.google.com/file/d/${id}/preview`}
            className="absolute inset-0 w-full h-full"
            allow="autoplay; fullscreen; encrypted-media"
            allowFullScreen
            title={name || caption || "Testimonial video"}
          />
        ) : (
          <button
            className="absolute inset-0 w-full h-full group cursor-pointer"
            onClick={() => setPlaying(true)}
            aria-label={`Play video${name ? ` from ${name}` : ""}`}
            data-testid={`drive-video-play-${id}`}
          >
            {thumbStage < 2 ? (
              <img
                src={
                  thumbStage === 0
                    ? `https://drive.google.com/thumbnail?id=${id}&sz=w800`
                    : `https://lh3.googleusercontent.com/d/${id}`
                }
                alt={name || caption || "Video thumbnail"}
                loading="lazy"
                className="w-full h-full object-cover"
                onError={() => setThumbStage(thumbStage + 1)}
              />
            ) : (
              <span className="absolute inset-0 bg-ink" />
            )}
            <span className="absolute inset-0 flex items-center justify-center">
              <span className="w-14 h-14 rounded-full bg-brand text-white flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                <Play size={22} className="ml-1" />
              </span>
            </span>
          </button>
        )}
      </div>
      {(name || caption) && (
        <figcaption className="mt-2.5 text-center">
          {name && <p className="font-bold text-sm text-ink">{name}</p>}
          {caption && <p className="text-xs text-muted mt-0.5">{caption}</p>}
        </figcaption>
      )}
    </figure>
  );
}
